import React, {Fragment} from "react";
import { calculateAge } from "../../../helpers/AgeHelper";
import { formatAgeShort, formatGenderShort, formatHeight, formatWeight } from "../../../helpers/FormatHelper";
import { Patient } from "../../../models/Patient";
import {useTranslation} from "react-i18next";
import {useLongPress} from "../../../hooks";

interface PatientProps {
    patient: Patient;
    onClick: () => void;
    onContextMenu?: (anchorX: number, anchorY: number) => void;
    compact?: boolean;
}

export const PatientShort: React.FC<PatientProps> = ({ patient, onClick, onContextMenu, compact = false }: PatientProps) => {
    const {t} = useTranslation();
    const contextMenuHandler = (event: React.MouseEvent<HTMLTableRowElement>) => {
        if (!onContextMenu) {
            return;
        }
        event.preventDefault();
        onContextMenu(event.clientX, event.clientY);
    };
    // touch: long press opens the context menu (iOS does not fire contextmenu)
    const longPress = useLongPress(onContextMenu);
    return (
        <tr onClick={onClick} onContextMenu={onContextMenu ? contextMenuHandler : undefined} {...longPress}>
            {compact ?
                <td className="text-left list-cell-wrap">
                    {patient.name}
                    <div className="list-cell-subtitle">
                        {[formatGenderShort(t, patient.gender), formatAgeShort(calculateAge(patient.birthDate)),
                            formatHeight(t, patient.height, patient.heightUnits), formatWeight(t, patient.weight, patient.weightUnits)].join(" • ")}
                    </div>
                </td> :
                <Fragment>
                <td>{patient.name}</td>
                <td width="1" align="center">{formatGenderShort(t, patient.gender)}</td>
                <td width="1" align="center">•</td>
                <td width="1" align="center">{formatAgeShort(calculateAge(patient.birthDate))}</td>
                <td width="1" align="center">•</td>
                <td width="1" align="center">{formatHeight(t, patient.height, patient.heightUnits)}</td>
                <td width="1" align="center">•</td>
                <td width="1" align="center">{formatWeight(t, patient.weight, patient.weightUnits)}</td>
                </Fragment>
            }
        </tr>
    );
}